import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";

import { Translate, Localize, translate } from "react-i18nify";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { setTranslations, setLocale } from "react-i18nify";
import QRCode from "react-qr-code";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";
import KioskStylesReact from "./../../../../KioskStylesReact";

import BackspaceIcon from "@mui/icons-material/Backspace";

import {
  Button,
  IconButton,
  InputAdornment,
  Grid,
  TextField,
  Typography
} from "@mui/material";

import PhoneKeypad from "./PhoneKeypad";

import KioskStepper from "./../../Components/Stepper/KioskStepper";
import KioskDetail from "./../../Components/Shared/KioskDetail";

import CircleButton from "./../../Components/Buttons/CircleButton";
import Logo from "./../../Components/Logo";
import LanguageButtons from "./../../Components/Shared/LanguageButtons";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";

import formatFirstNameLastInitial from "./../../HelperFunctions/formatFirstNameLastInitial";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import { useTheme, createTheme, ThemeProvider } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

import { getErrorTranslateID } from "./../../HelperFunctions/ErrorDisplayFunctions";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal";

let env = require("./../../../../env");

export default function HorizontalLayout({
  overrideCode,
  setOverrideCodeFunc,
  nextFunc,
  loading,
  errorCode,
  clearErrorFunc,
  isNotMobile,
  kioskkey,
  workflowmode,
  getKioskConfiguration
}) {
  const theme = useTheme();

  const htheme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: ({ ownerState }) => ({
            ...{
              height: "7vh",
              width: "21vw",
              fontSize: "8vh"
            }
          }),
          input: ({ ownerState }) => ({
            ...{
              textAlign: "center",
              padding: "16.5px 14px"
            }
          })
        }
      }
    }
  });

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  // //Check and generate a UniqueKioskID
  // useEffect(() => {
  //   let kioskID = localStorage.getItem("kioskID");
  //   console.log("kioskID from localStorage", kioskID);

  //   let newKioskID = null;

  //   if (kioskID == null) {
  //     //Generate a new one!
  //     if (crypto.randomUUID != null) {
  //       newKioskID = crypto.randomUUID();
  //       localStorage.setItem("kioskID", newKioskID);
  //     } else {
  //       //TODO: Remove this case, as this is NOT RECOMMENDED!
  //       console.log(
  //         "[WARNING] crypto.randomUUID doesn't exist, HTTPS is probably not enabled. Using fallback."
  //       );
  //       newKioskID = mockUniqueID(32);
  //       localStorage.setItem("kioskID", newKioskID);
  //     }
  //   }

  //   //We dont auto login, since the error is probably that the Subscription is DIABLED
  //   //   //if Kiosk Key available, attempt auto login
  //   //   let subscriptionID = localStorage.getItem("subscriptionID");
  //   //   if (subscriptionID !== null) {
  //   //     //auto login
  //   //     setKioskkey(subscriptionID);
  //   //   }
  // }, []);

  const kioskstyles = useKioskHorizontalStyles();

  const backspacepress = event => {
    if (overrideCode.length > 0) {
      setOverrideCodeFunc(overrideCode.substring(0, overrideCode.length - 1));
    }
  };

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      style={kioskstyles.GridFullHeightFix}
    >
      <Grid item xs={12} sm={6} style={KioskStylesReact().flexLeftPanel}>
        <div style={kioskstyles.flexLeftPanelContents}>
          <div style={kioskstyles.flexParentPanel}>
            <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
              <Logo />
            </div>
            <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
              <div style={kioskstyles.kioskDetails}>
                <div
                  class="fontSecondaryText"
                  style={kioskstyles.whiteSubtitleText}
                >
                  <Translate
                    value="application.welcome"
                    name={formatFirstNameLastInitial(
                      customerFirstName,
                      customerLastName
                    )}
                  />
                </div>
                <br />
                <KioskDetail getKioskConfiguration={getKioskConfiguration} />
                <br />
                <div
                  class="fontSecondaryText"
                  style={{
                    ...kioskstyles.whiteBodyText,
                    ...kioskstyles.kioskDetailsSpaceBetween
                  }}
                >
                  <Translate
                    value="application.kioskdetail.returningnumbags"
                    count={numBags}
                  />
                </div>
              </div>
            </div>
            <div style={kioskstyles.flexPanelLayoutB_BotContainer}>
              <KioskStepper
                activeStep={1}
                backUrl={"/numbags"}
                workflowmode={workflowmode}
                getKioskConfiguration={getKioskConfiguration}
              />
            </div>
          </div>
        </div>
      </Grid>
      <FlexRightPanel isNotMobile={isNotMobile}>
        <div style={kioskstyles.flexRightPanelContents}>
          <div style={kioskstyles.flexParentPanel}>
            <div style={kioskstyles.flexPanelLayoutB_TopContainer}>
              <SubtitleWrapper isNotMobile={isNotMobile}>
                <Typography
                  variant="h4"
                  style={{ ...kioskstyles.RightPanelTitle, fontSize: "4vh" }}
                >
                  <Translate value="application.submissionapproval.title" />
                </Typography>
                <Typography
                  variant="h4"
                  style={{
                    ...kioskstyles.RightPanelTitle,
                    fontSize: "2.5vh",
                    marginTop: "2vh",
                    color: "red"
                  }}
                >
                  <Translate
                    value="application.submissionapproval.instructions"
                    count={numBags}
                  />
                </Typography>
              </SubtitleWrapper>
            </div>
            <div style={kioskstyles.flexPanelLayoutB_MidContainer}>
              <ThemeProvider theme={htheme}>
                <TextField
                  id="KioskApprovalKey"
                  label=""
                  type="password"
                  value={overrideCode}
                  onChange={event => {
                    setOverrideCodeFunc(event.target.value);
                  }}
                  inputProps={{
                    readOnly: true,
                    style: { cursor: "pointer" } // Optional: keeps the cursor visible
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            backspacepress();
                          }}
                          edge="end"
                        >
                          <BackspaceIcon style={{ fontSize: "3.8vh" }} />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  style={{
                    marginTop: "4.4vh"
                  }}
                  sx={{
                    height: "10vh", // Scales with viewport height
                    "& .MuiInputBase-root": {
                      height: "100%" // Fill the container
                    },
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white"
                    }
                  }}
                />
              </ThemeProvider>
              <Typography
                variant="body2"
                class="fontSecondaryText"
                style={{
                  color: "red",
                  marginTop: theme.spacing(0.5),
                  fontSize: "clamp(12px, 1.3vw, 20px)",
                  textAlign: "center"
                }}
              >
                <Translate value={getErrorTranslateID(errorCode)} />
              </Typography>
              <PhoneKeypad
                phonenumber={overrideCode}
                setPhonenumber={setOverrideCodeFunc}
                keypadDone={nextFunc}
                loading={loading}
                errorMessage={""}
                clearErrorFunc={clearErrorFunc}
              />
            </div>
            <div style={kioskstyles.flexPanelLayoutB_BotContainer}>
              {/* <Button
                variant="contained"
                disabled={loading}
                onClick={nextFunc}
                style={{ ...kioskstyles.textButtons, marginBottom: "0px" }}
              >
                <span class="fontSecondaryText">
                  <Translate value="application.next" />
                </span>
              </Button> */}
            </div>
          </div>
        </div>
      </FlexRightPanel>
      <PrinterConnectionModal />
    </Grid>
  );
}
